WiseMetering.Views.IndicatorMetals = WiseMetering.Views.Content.extend({
    fromField: null,
    template: 'templates/indicators/metals',
    toField: null,

    hasFullPermissions: function() {
        const type = this.model.get('type');
        if (WiseMetering.currentUser.isSuperUser() || type === 'import') {
            return true;
        }
    },

    createTable: function() {
        const timezone = this.model.timezone();
        WiseMetering.utils.addLoader('#metals-table', 80);

        const mode = WiseMetering.currentUser.isSuperUser() ? 'extended' : 'standard';

        this.model.getMetals(
            this.fromField.val(),
            this.toField.val(),
            mode
        ).done(metals => {
            const collection = metals.map(row => ({
                id: row.timestamp,
                bucket_id: row.bucket_id,
                computed_value: row.computed_value,
                date: moment.tz(row.timestamp * 1000, timezone).format('YYYY-MM-DD HH:mm'),
                difference: row.difference,
                timestamp: row.timestamp,
                value: row.value
            }));

            let toolbar_actions = {},
                columns = {
                    date: 'Date',
                    value: `Value (${this.model.get('unit')})`
                };

            if (mode === 'extended') {
                columns = { timestamp: 'Timestamp', date: 'Date', value: 'Value', computed_value: 'Computed Value', bucket_id: 'Bucket' };
                if (this.model.kind().get('cumulative')) {
                    columns['difference'] = 'Difference';
                }
            }

            if (this.hasFullPermissions()) {
                toolbar_actions = {
                    select_all: {},
                    new: {
                        view_call: () => new WiseMetering.Views.NewIndicatorMetal({ indicator_id: this.model.id })
                    },
                    custom_edit: {
                        view_call: ({ target, timestamp, value }) => new WiseMetering.Views.EditIndicatorMetal({ model: this.model, target, timestamp, value })
                    },
                    custom_delete: {
                        permission: 'manager',
                        view_call: ({ target, timestamps }) => new WiseMetering.Views.RemoveIndicatorMetal({ model: this.model, target, timestamps })
                    },
                    exportBuckets: {
                        icon: 'csv',
                        label: i18next.t('ui.actions.export_buckets'),
                        view_call: () => window.open(this.model.exportBucketsUrl())
                    }
                };
            }

            this.table = new WiseMetering.Views.Table({
                id: 'metals',
                collection,
                toolbar_actions,
                columns,
                custom: {
                    checkbox: true
                },
                aLengthMenu: [96, 96 * 7, 96 * 14, 48, 24, 12],
                createdRow: (row, rowData) => {
                    if (rowData.value === null || rowData.value === undefined) {
                        $(row).find('td.control.checkbox').empty();
                    }
                }
            });
            $(this.body.el).find('div#metals-table').html(this.table.el);
        });
    },

    onClose: function() {
        if (this.xhr && this.xhr.abort && typeof (this.xhr.abort) === 'function') {
            this.xhr.abort();
        }
        if (this.table && this.table.remove && typeof (this.table.remove) === 'function') {
            this.table.remove();
        }
    },

    onShow: function() {
        const now = moment();
        let { from, to } = ParamsService;

        this.showMetals();

        from = from ? moment(from, 'YYYY-MM-DD') : now.startOf('year');
        to = to ? moment(to, 'YYYY-MM-DD') : now;

        this.fromField = $(this.body.el).find('#date_time_from');
        this.fromField.val(from.format('YYYY-MM-DD'));

        this.toField = $(this.body.el).find('#date_time_to');
        this.toField.val(to.format('YYYY-MM-DD'));

        $(this.body.el).find('#submit_time').click(() => {
            this.updateFields();
            if (this.fromField.val() && this.toField.val()) {
                this.createTable();
            }
        });

        this.fromField.datepicker({ dateFormat: 'yy-mm-dd', changeMonth: true, changeYear: true, showOtherMonths: true, onSelect: from => ParamsService.setParams({ from }) });
        this.toField.datepicker({ dateFormat: 'yy-mm-dd', changeMonth: true, changeYear: true, showOtherMonths: true, onSelect: to => ParamsService.setParams({ to }) });

        this.createTable();
    },

    showMetals: function() {
        if (!WiseMetering.currentUser.isSuperUser()) {
            return;
        }

        let text = '';
        text += `<b>Indicator Max Value:</b> ${this.model.get('max_value')} ${this.model.get('unit')}, `;
        text += `<b>Indicator Min Value:</b> ${this.model.get('min_value')} ${this.model.get('unit')}`;

        this.model.buckets().each(function(bucket) {
            let metal = '<br/><br/>';
            let origin = bucket.get('origin');
            if (origin !== 'measurement') {
                origin = `${origin} (${bucket.get('source_kind')})`;
            }

            metal += `<b>ID:</b> ${bucket.id}, `;
            metal += `<b>Table:</b> ${bucket.get('buckets_table_name')}, `;
            metal += `<b>Source:</b> ${origin}, `;
            metal += `<b>Start:</b> ${bucket.get('indicator_start_at')} (${moment.unix(bucket.get('indicator_start_at')).utc().format()}), `;
            metal += `<b>Finish:</b> ${bucket.get('indicator_finish_at')} (${moment.unix(bucket.get('indicator_finish_at')).utc().format()}), `;
            metal += `<b>Ratio:</b> ${bucket.get('ratio')}, `;
            metal += `<b>Min:</b> ${bucket.get('min_value')}, `;
            metal += `<b>Max:</b> ${bucket.get('max_value')}`;

            text += metal;
        });

        this.$('#metals-info').html(JST['templates/ui/components/notice']({ text }));
    },

    updateFields: function() {
        this.fromField.datepicker('option', 'maxDate', this.toField.val());
        this.toField.datepicker('option', 'minDate', this.fromField.val());
    }
});
